import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  FormControl,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Orders } from "../components/Orders";
import Swal from "sweetalert2";
import orderService from "../services/orderService.jsx";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import outWardService from "../services/outWardService.jsx";
import ecommercePlaceService from "../services/ecommercePlaceService.jsx";
import marketplacesService from "../services/marketplacesService.jsx";
import { set } from "react-hook-form";

const CARGO_COMPANIES = [
  { id: 1, name: "Yurtiçi" },
  { id: 2, name: "Aras" },
  { id: 3, name: "Sürat" },
  { id: 4, name: "Horoz" },
  { id: 5, name: "MNG" },
  { id: 6, name: "Ptt" },
  { id: 7, name: "Ceva" },
  { id: 8, name: "Tex" },
  { id: 9, name: "Sendeo" },
];

export const OrdersPage = () => {
  // State tanımlamaları
  const [orders, setOrders] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterParams, setFilterParams] = useState({});
  const [selectedCargo, setSelectedCargo] = useState("");
  const [showNotSupportedModal, setShowNotSupportedModal] = useState(false);
  const [allPlaces, setAllPlaces] = useState([]);
  const [cargoCompanies, setCargoCompanies] = useState([]);
  const navigate = useNavigate();
  // Sayfa yüklendiğinde kullanıcı ID'sini al
  const authUserId = useSelector((state) => state?.auth?.user?.id);

  // Orders bileşeninden gelen sayfa değişikliklerini dinle
  useEffect(() => {
    if (authUserId) {
      fetchOrders(filterParams);
    }
  }, [authUserId, currentPage, pageSize]);

  // Siparişleri getiren fonksiyon
  const fetchOrders = async (filters = {}) => {
    try {
      setIsLoading(true);
      const response = await orderService.fetchOrders(
        authUserId,
        currentPage,
        pageSize,
        false,
        filters
      );
      if (response && response.status) {
        setOrders(response.data.data || []);
        setTotalOrders(response.data.recordsTotal || 0);
      } else {
        console.error("Siparişler alınamadı:", response);
        Swal.fire({
          title: "Hata!",
          text: "Siparişler alınamadı. Lütfen daha sonra tekrar deneyin.",
          icon: "error",
          timer: 3000,
        });
      }
    } catch (error) {
      console.error("Siparişler getirilirken hata oluştu:", error);
      Swal.fire({
        title: "Hata!",
        text: "Siparişler yüklenirken bir hata oluştu",
        icon: "error",
        timer: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Filtreleme işlemini gerçekleştiren fonksiyon
  const handleFilters = (filters) => {
    setFilterParams(filters);
    setCurrentPage(1);
    fetchOrders(filters);
  };

  // Sayfa değişimini gerçekleştiren fonksiyon
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // Sayfa boyutu değişimi
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setCurrentPage(1);
  };

  // Kargo firması değişikliği
  const handleCargoChange = (event) => {
    setSelectedCargo(event.target.value);
  };
  // Kargo değişikliği yapma
const handleCargoUpdate = async () => {
    if (!selectedCargo || selectedOrder.length === 0) {
      Swal.fire({
        title: "Uyarı!",
        text: "Lütfen kargo firması ve en az bir sipariş seçin.",
        icon: "warning",
        timer: 2000,
      });
      return;
    }

    const referenceMarketPlaceId = selectedOrder[0]?.marketPlace?.id;
    
    const sameMarketplaceOrders = selectedOrder.filter(
      (order) => order?.marketPlace?.id === referenceMarketPlaceId
    );

    const nonTrendyolOrders = sameMarketplaceOrders.filter(
      (order) => order?.marketPlace?.id !== 1 && order?.marketPlace?.id !== 2 && order?.marketPlace?.id !== 4
    );
    
    if (nonTrendyolOrders.length > 0) {
      setShowNotSupportedModal(true);
      return;
    }

    try {
      const result = await Swal.fire({
        title: "Kargo Değişikliği",
        text: `${sameMarketplaceOrders.length} adet ${sameMarketplaceOrders[0].marketPlace.name} siparişinin kargo firmasını değiştirmek istediğinize emin misiniz?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (result.isConfirmed) {
        setIsLoading(true);

        
        try {
          const responses = [];
          let successCount = 0;
          let failCount = 0;

          for (let i = 0; i < sameMarketplaceOrders.length; i++) {
            const order = sameMarketplaceOrders[i];
            
            try {
              
              const response = await orderService.updateOrderCargo(order.marketPlace.name, {
                orderId: order.id,
                cargoCompanyId: selectedCargo.id,
                providerName: selectedCargo.shortName,
                orderLineId: order.orderLines[0].lineId,
                providerLongName: selectedCargo.name,
              });
              responses.push(response);
              
              if (response.data.state !== 9) {
                successCount++;
              } else {
                failCount++;
              }
              
              if (i < sameMarketplaceOrders.length - 1) {
                await new Promise(resolve => setTimeout(resolve, 100)); 
              }
              
            } catch (orderError) {
              failCount++;
              console.error(`Sipariş ID ${order.id} için hata:`, orderError);
              responses.push({ error: orderError.message });
            }
          }
          
          setIsLoading(false);
          
          const failedUpdates = failCount;
          if (failedUpdates === 0) {
            await Swal.fire({
              title: "Başarılı!",
              text: `${successCount} adet sipariş için kargo firması değişikliği başarıyla yapıldı. Değişiklik 10 dakika içerisinde yansıyacaktır.`,
              icon: "success",
              timer: 3000,
            });
          } else if (successCount > 0) {
            await Swal.fire({
              title: "Kısmi Başarı!",
              text: `${successCount} adet sipariş başarıyla güncellendi, ${failedUpdates} adet sipariş güncellenemedi.`,
              icon: "warning",
              timer: 3000,
            });
          } else {
            await Swal.fire({
              title: "Başarısız!",
              text: "Hiçbir sipariş için kargo firması değişikliği yapılamadı. Lütfen daha sonra tekrar deneyin.",
              icon: "error",
              timer: 3000,
            });
          }
        } catch (error) {
          if (error.message === "NOT_SUPPORTED_MARKETPLACE") {
            setShowNotSupportedModal(true);
            return;
          }
          throw error;
        }

        fetchOrders(filterParams);
        setSelectedOrder([]);
        setSelectedCargo("");
      }
    } catch (error) {
      setIsLoading(false);
      Swal.fire({
        title: "Hata!",
        text: error.message || "Kargo değişikliği yapılamadı.",
        icon: "error",
        timer: 3000,
      });
    }
  };

  const handleCreateRequest = () => {
    navigate("/user-tasks");
    setShowNotSupportedModal(false);
  };

  const isDisabled = selectedOrder.length === 0 ;
  useEffect(() => {
    const fetchModalData = async () => {
      try {

        const [marketRes, ecommerceRes] = await Promise.all([
          marketplacesService.getMarketPlacesAccountsApi(authUserId),
          ecommercePlaceService.getEcommercePlaceAccountsApi(authUserId)
        ]);
        const combinedData = [
          ...marketRes?.data?.data?.data.map((place) => ({ ...place, type: "marketplace" })),
          ...ecommerceRes?.data?.data?.data.map((place) => ({ ...place, type: "ecommerce" }))
        ];

        setAllPlaces(combinedData);
      } catch (err) {
        setError(err?.response?.data?.message || err?.message || "Veriler alınırken hata oluştu.");
      }
    };

    fetchModalData();
  }, []);
  const createRequestBody = (
    selectedPlaceName,
    allAccounts,
  ) => {
    // Pazaryeri ayarlarını filtrele ve yapılandır
    const marketPlaceSettings = allAccounts
      .filter((account) => account.marketPlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        marketPlaceId: account.marketPlaceId || 0,
        marketPlaceName: account.marketPlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));
    const ecommercePlaceSettings = allAccounts
      .filter((account) => account.ecommercePlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));
    return {
      marketPlaceSetting: marketPlaceSettings,
      ecommercePlaceSettings,
      orderLineId: selectedOrder[0]?.orderLines[0]?.lineId || 0,
      shipmentPackageId: selectedOrder[0]?.orderLines[0]?.packageNumber,
    };
  };
  // Kargo firmalarını getiren fonksiyon
  const getCargoProvider = async () => {
    try {
      const body = createRequestBody(selectedOrder[0]?.marketPlace?.name || selectedOrder[0]?.ecommercePlace?.name, allPlaces)
      const response = await outWardService.getCargoProvider(selectedOrder[0]?.marketPlace?.name || selectedOrder?.ecommercePlace?.name, body);
      setCargoCompanies(response);
    } catch (exx) {
      setCargoCompanies(CARGO_COMPANIES);
    }
  }
  useEffect(() => {
    if (selectedOrder.length > 0) {
      getCargoProvider();
    }
  }, [selectedOrder]);
  console.log("Cargo Companies:", cargoCompanies);
  return (
    <Paper
      elevation={0}
      sx={{
        padding: 3,
        backgroundColor: "#fff",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          padding: 3,
          backgroundColor: "#F7F9FC",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          marginBottom: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "stretch", md: "center" },
            justifyContent: "space-between",
            gap: { xs: 2, md: 0 },
            marginBottom: 3,
          }}
        >
          <Box
            sx={{ display: "flex", alignItems: "center", mb: { xs: 2, md: 0 } }}
          >
            <Box
              sx={{ width: 4, height: 24, backgroundColor: "#1F1B45", mr: 1 }}
            />
            <Typography
              variant="h6"
              sx={{
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                fontWeight: "bold",
                color: "#333",
                fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
              }}
            >
              Siparişler
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "stretch", sm: "center" },
              gap: { xs: 2, sm: 2, md: 2 },
              width: { xs: "100%", md: "auto" },
            }}
          >
            <FormControl
              sx={{ minWidth: { xs: "100%", sm: 180, md: 200 } }}
              size="small"
            >
              <Select
                value={selectedCargo}
                onChange={handleCargoChange}
                displayEmpty
                sx={{
                  backgroundColor: "white",
                  width: "100%",
                  "& .MuiSelect-select": {
                    padding: { xs: "8px 10px", sm: "8px 14px" },
                    fontSize: { xs: "0.95rem", sm: "1rem" },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Kargo Firması Seçin
                </MenuItem>
                {cargoCompanies.map((company) => (
                  <MenuItem key={company.id} value={company}>
                    {company.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              onClick={handleCargoUpdate}
              disabled={isDisabled}
              sx={{
                px: { xs: 2, sm: 3 },
                py: { xs: 1, sm: 1.5 },
                backgroundColor: isDisabled ? "#E0E0E0" : "#1F1B45",
                color: isDisabled ? "#A0A0A0" : "white",
                borderRadius: "8px",
                fontWeight: 600,
                fontSize: { xs: "0.95rem", sm: "0.95rem", md: "0.875rem" },
                textTransform: "none",
                width: { xs: "100%", sm: "auto" },
                minWidth: { xs: "auto", sm: "180px" },
                boxShadow: { xs: 1, sm: 0 },
                "&:hover": {
                  backgroundColor: isDisabled ? "#E0E0E0" : "#2C285A",
                },
                "&.Mui-disabled": {
                  backgroundColor: "#E0E0E0",
                  color: "#A0A0A0",
                },
              }}
            >
              Kargo Değişikliği Yap
            </Button>
          </Box>
        </Box>
      </Box>
      <Dialog
        open={showNotSupportedModal}
        onClose={() => setShowNotSupportedModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            bgcolor: "#1F1B45",
            color: "white",
            py: 2,
          }}
        >
          Desteklenmeyen Pazaryeri
        </DialogTitle>
        <DialogContent sx={{ py: 3 }}>
          <Typography>
            Şu an için sadece Trendyol,Hepsiburada ve Çiçeksepeti siparişlerinde kargo değişikliği
            yapılabilmektedir. Diğer pazaryerleri için entegrasyon
            çalışmalarımız devam etmektedir.
          </Typography>
          <Typography sx={{ mt: 2 }}>
            Bu özelliğin eklenmesi için talep oluşturabilirsiniz.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setShowNotSupportedModal(false)}
            sx={{
              color: "#1F1B45",
              "&:hover": {
                bgcolor: "rgba(31, 27, 69, 0.04)",
              },
            }}
          >
            Kapat
          </Button>
          <Button
            onClick={handleCreateRequest}
            variant="contained"
            sx={{
              bgcolor: "#1F1B45",
              "&:hover": {
                bgcolor: "#2C285A",
              },
            }}
          >
            Talep Oluştur
          </Button>
        </DialogActions>
      </Dialog>
      <Orders
        orders={orders || []}
        totalOrders={totalOrders}
        setSelectedOrder={setSelectedOrder}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        onFiltersChange={handleFilters}
        isLoading={isLoading}
      />
    </Paper>
  );
};
